// extracted by mini-css-extract-plugin
module.exports = {"purchaseForm":"Form_purchaseForm__kaMR1","purchaseFormContainer":"Form_purchaseFormContainer__581HT"};